import type { SeparatorProps as BaseProps } from '@radix-ui/react-separator';
import * as _Separator from '@radix-ui/react-separator';
import classNames from 'classnames';
import React from 'react';
import type { ExtendWithCommonProps } from '../../types';
import { Layout, type LayoutProps } from '../layout/layout';
import scss from './divider.module.scss';

export type DividerProps = ExtendWithCommonProps<
  Pick<LayoutProps, 'margin' | 'height' | 'display' | 'backgroundColor'>,
  {
    /** Divider's orientation. */
    orientation: BaseProps['orientation'];
  }
>;

/**
 * Element used to divide content horizontally or vertically.
 *
 * @link https://prod.web-components.srv.smart.com/?path=/docs/components-dialog--docs
 */
export const Divider = React.forwardRef<
  React.ElementRef<typeof _Separator.Root>,
  DividerProps
>(
  (
    { orientation, backgroundColor = 'div-default', className, ...props },
    ref,
  ) => {
    const classes = classNames(scss['divider'], className);
    return (
      <Layout backgroundColor={backgroundColor} {...props} asChild>
        <_Separator.Root
          className={classes}
          orientation={orientation}
          ref={ref}
        />
      </Layout>
    );
  },
);

Divider.displayName = 'Divider';
